import type { FC } from 'react';
import { FlowsTT } from 'features/cabinet';
import { CabinetTitlePage } from 'components/layout';
import { LinkButton } from 'components/common';
import { Guard, usePermissionGuard } from 'features/login';
import { Add } from '@mui/icons-material';

const FlowsPage: FC = () => {
  const { accessToViewTiktokflow, accessToAddTiktokflow } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToViewTiktokflow} fallback>
      <CabinetTitlePage
        title={'Flows'}
        endAdornment={
          <LinkButton
            to={'/cabinet/tiktok/flows/add'}
            title={'Add flow'}
            disabled={!accessToAddTiktokflow}
            startIcon={<Add />}
          />
        }
      />
      <FlowsTT />
    </Guard>
  );
};

export default FlowsPage;
